export default {
    SERVER_ERROR: "Ha ocurrido un error interno, por favor pruebe nuevamente.",
    SERVER_UNAVAILABLE: "El servidor no está disponible, por favor pruebe nuevamente.",
    FIREBASE_AUTH: "Firebase not available.",
}



// WEBPACK FOOTER //
// ./src/constants/errors.js